/**
 * @desc 账号更新提示组件
 * @time 2023-08-18 17:23:12
 * @user simxin
 */

import { t } from '@src/utils/translate';
import { Modal, Button } from '@tencent/tea-component';
import { getUin, getSaasToken } from '@src/utils/cookies';

/**
 * @desc 监听账号变更提示，页面加载获取skey后再监听
 * @trigger 触发调用
 * document.body.dispatchEvent(
 *   new CustomEvent('account:change', {})
 * );
 *
 * 账号变更：
 * 1. 当前浏览器账号重新登录，无需处理
 * 2. 当前浏览器登录其他账号，刷新页面
 * 3. 其他浏览器账号被登录，需要接口支持
 *
 * 触发路径：
 * 1. storage 事件，跨标签页实时检测
 * 2. 接口调用前判断
 */
export const changeAccountEvent = (uin: string, token: string) => {
  const createModel = () => {
    Modal.show({
      caption: t('Login account changed'),
      size: 's',
      disableEscape: true,
      disableCloseIcon: true,
      children: (
        <>
          <Modal.Body>
            {t(
              'You have logged in to another account from another device, browser, or page tab. Please refresh the page to log in with that account, or switch to another account.',
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              {t('Refresh')}
            </Button>
            <Button
              onClick={() => {
                window.location.href = `//${window.AVPORTAL_HOST}/login?pro=another&s_url=https://${window.AVCONSOLE_HOST}`;
              }}
            >
              {t('Log in to another account')}
            </Button>
          </Modal.Footer>
        </>
      ),
    });
  };

  document.body.addEventListener<any>('account:change', createModel);

  const checkAccount = () => {
    const currentToken = getSaasToken();
    const currentUin = getUin();
    if (!currentToken || !currentUin) return;
    if (token !== currentToken && uin !== currentUin) {
      document.body.dispatchEvent(new CustomEvent('account:change', {}));
    }
  };

  // 监听跨标签页的账号变更通知
  const storageHandler = (e: StorageEvent) => {
    if (e.key === 'check_account_change') {
      checkAccount();
    }
  };
  window.addEventListener('storage', storageHandler);
  // 通知其他标签页检测账号是否已变更
  localStorage.setItem('check_account_change', Date.now().toString());
};


